module.exports = __webpack_public_path__ + "img/maid.159beded.svg";